import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.expensesTypesList,"item-value":"id","item-text":"expenseTypeName","label":"Expense Type","clearable":_vm.clearable ? _vm.clearable : false,"rules":[_vm.requiredCheck()],"outlined":""},model:{value:(_vm.expenseTypeIdValue),callback:function ($$v) {_vm.expenseTypeIdValue=$$v},expression:"expenseTypeIdValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }